import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import RingBackground from "../../../components/RingBackground.js";
import { RING_SIZE } from "../../../lib/constants.js";

export default function AlephLogo({ locales }) {
  return (
    <Box
      alignItems="center"
      display="flex"
      id="aleph-logo"
      justifyContent="center"
      sx={{ position: "relative" }}
    >
      <Typography
        component="cite"
        sx={{
          fontStyle: "normal",
          fontWeight: "bold",
          letterSpacing: 3,
          position: "absolute",
          textTransform: "uppercase",
          top: RING_SIZE / 5,
        }}
        variant="h5"
      >
        {locales["home.title"]}
      </Typography>
      <Box
        alt={locales["home.title"]}
        component="img"
        src="/assets/aleph-logo.png"
        sx={{
          borderRadius: "50%",
          height: RING_SIZE / 3,
          objectFit: "cover",
          position: "absolute",
        }}
      />
      <Typography
        component="cite"
        sx={{
          bottom: RING_SIZE / 4.5,
          fontStyle: "normal",
          fontWeight: "bold",
          letterSpacing: 2,
          position: "absolute",
        }}
        variant="subtitle1"
      >
        {locales["home.subtitle"]}
      </Typography>
      <RingBackground />
    </Box>
  );
}
